import { render } from "./LeaderBoardPoleys.vue?vue&type=template&id=fdadbd92&scoped=true"
import script from "./LeaderBoardPoleys.vue?vue&type=script&lang=js"
export * from "./LeaderBoardPoleys.vue?vue&type=script&lang=js"

import "./LeaderBoardPoleys.vue?vue&type=style&index=0&id=fdadbd92&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdadbd92"]])

export default __exports__